<template>
    <div v-if="totalWithoutVouchers() > 0" class="container p-5 pb-0 to-pay bg-white w-100">
        
        <div class="row justify-content-center ">
            <div class="col-24 p-0 ">
                <h3>{{title}}</h3>

                <div class="row ">
                    <div class="p-4">
                        <div class="row">
                            <div class="col-14">
                                <div class="row mb-3" v-for="(leg, index) in booking.legs">
                                    <div class="col-24">
                                        <div class="row">
                                            <div class="col-12">
                                                Room {{leg.leg}}
                                            </div>
                                            <div class="col-12">
                                                <strong>&pound;{{priceFormatted(calculate(leg))}}</strong>
                                            </div>
                                        </div>

                                        <div class="row" v-if="getSpaUpgradeAmount(leg) > 0">
                                            <div class="col-12">
                                                Spa upgrades
                                            </div>
                                            <div class="col-12">
                                                <strong>&pound;{{priceFormatted(getSpaUpgradeAmount(leg))}}</strong>
                                            </div>
                                        </div>

                                        <div class="row" v-if="leg.packages">
                                            <div class="col-12">
                                                Add Ons
                                            </div>
                                            <div class="col-12">
                                                <strong>&pound;{{priceFormatted(getAddOnsTotal(leg))}}</strong>
                                            </div>
                                        </div>


                                        <div class="row" v-if="appliedVoucherValue(leg) > 0">
                                            <div class="col-12">
                                                Gift Vouchers
                                            </div>
                                            <div class="col-12">
                                                <div class="gift-voucher">
                                                    <strong>-&pound;{{priceFormatted(appliedVoucherValue(leg))}}</strong>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div class="bordered col-10">
                                <span class="total">
                                    Total:<span class="total-price">&pound;{{priceFormatted(total())}}</span>
                                </span>
                            </div>



                        </div>

                    </div>


                </div>

                <div v-if="!isTodayPayment">
                    <info-box v-bind:type="'alert'">
                        <template v-slot:body>
                            <span class="heading">
                                Payment due on arrival
                            </span>

                            <div>
                         
                                <ul>
                                    <li>A credit card guarantee will be taken on the lead booker's card to secure your booking</li>
                                </ul>
                            </div>
                        </template>
                    </info-box>
                </div>
                <div v-else>
                    <info-box v-bind:type="'success'">
                        <template v-slot:body>
                            <span class="heading">
                                Payment due today
                            </span>

                            <div>
                                <p>
                                    Payment for this room will be taken from your selected payment method to complete this booking. Please note transactions can take up to 24 hours to process.
                                </p>
                            
                            </div>
                        </template>
                    </info-box>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { store } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import moment from 'moment';

    export default {
        name: 'ToPay',
        props: {
            isTodayPayment: null,
          
        },
        components:
            { InfoBox },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            title() {
                if (this.isTodayPayment) {
                    return "To pay today:"
                }
                return "To pay on arrival:"
            },
            stayVouchers() {
                let result = [];

                if (this.booking.monetaryVouchers != undefined && this.booking.monetaryVouchers != null) {
                    return this.booking.monetaryVouchers.filter(item => !item.content.IsMonetary);
                }

                return result;
            },

        },
        methods: {
            getSpaUpgradeAmount(item) {
                var result = 0;
                if (item.spaPackages != null) {
                    for (var i = 0; i < item.spaPackages.length; i++) {
                        var it = item.spaPackages[i];

                        result += it.duration.PriceDifference;
                    }
                }

                return result;
            },

            stayVoucherValue(leg) {
      
                if (this.stayVouchers.length) {
                    let amount = this.stayVouchers.reduce(function (a, b) {

                        return b.voucher.unitPrice.amount + a
                    }, 0)


                    return amount;
                }
                return 0;
            },

            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },

            appliedVoucherValue(leg) {
            
                //need to make this handle other legs...
                //This is the actual total...
                let giftVoucherTotal = store.getters.giftVoucherMonetaryTotal;

                let stayVoucherValue = this.stayVoucherValue(leg);


                //nowe we need the total of all preceeding legs... so we can see whats available.
                let appliedTotal = 0;
                let legsToApply = store.getters.booking.legs.filter(item => item.leg < +(leg.leg))

                for (var li = 0; li < legsToApply.length; li++) {
                    appliedTotal = this.getTotal(legsToApply[li]);
                }
       
                let availableVouhcerValue = giftVoucherTotal - appliedTotal + stayVoucherValue;

                if (availableVouhcerValue > 0) {
                    let thisTotal = this.calculate(leg);// + this.getAddOnsTotal(leg);
                    if (thisTotal > availableVouhcerValue) {
                        return availableVouhcerValue;
                    } else {
                        return thisTotal;
                    }
                }
                return 0;
            },
            getTotal(leg) {
               
                let result = 0;
                result = result + this.getRoomRateAmount(leg);
                result = result + this.getIncludedAddOnsTotal(leg);
                result = result + this.getAddOnsTotal(leg);
                return result;
            },
            getRoomRateAmount(leg) {
                let result = 0;
                result = leg.rate.availableRate.Amount;
                return result;
            },

            getIncludedAddOnsTotal(leg) {
                let result = 0;
                if (leg.includedPackages != undefined && leg.includedPackages.length) {
                    for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                        let p = leg.includedPackages[pi];
                        let amount = p.Total;
                        result += amount;
                    }
                }
                return result;
            },
            getAddOnsTotal(leg) {
                let result = 0;

                if (leg.packages != undefined && leg.packages.length) {
                    for (let pi = 0; pi < leg.packages.length; pi++) {
                        let p = leg.packages[pi];
                        let amount = this.getPackagePrice(leg, p);
                        result += amount;
                    }
                }

                return result;
            },
            getPackagePrice(leg, p) {
                if (p.item.availability.AmountOverride != undefined) {
                    return p.quantity * p.item.availability.AmountOverride;
                }

                let amount = p.item.availability.Amount;
                let postingMode = p.item.availability.PriceCalculationMode;
                let result = 0;

                switch (postingMode) {
                    case 0:
                        result = amount * p.quantity;
                        break;
                    case 1:

                        result = amount * leg.guestQuota.Adults;
                        break;
                    case 2:
                        result = amount * (leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 3:
                        result = amount * (leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 4:
                        result = amount * p.quantity;
                        break;
                }
                return result;

            },

            total() {

                let result = 0;
                
                for (let li in this.booking.legs) {
                    let leg = this.booking.legs[li];
                    result += this.calculate(leg) + this.getAddOnsTotal(leg)
                        + this.getSpaUpgradeAmount(leg)
                        - this.appliedVoucherValue(leg);
                }

                return result;
            },
            totalWithoutVouchers() {

                let result = 0;

                for (let li in this.booking.legs) {
                    let leg = this.booking.legs[li];
                    result += this.calculate(leg) + this.getAddOnsTotal(leg);
                }

                return result;
            },
            getPackagesAmount(leg) {
                let totalAmount = 0;
                if (leg.includedPackages != undefined && leg.includedPackages.length) {
                    for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                        let p = leg.includedPackages[pi];
                        let amount = p.Total;
                        totalAmount += amount;
                    }
                }
                return totalAmount;
            },
            calculate(leg) {
                let result = 0;
                if (this.isTodayPayment) {
                    if (leg.rate.rateGroupRate.Apply1stNightDepositRule) {
                        result = leg.depositAmount + this.getPackagesAmount(leg);
                    }                        
                    else if (leg.rate.availableRate.RequiresDeposit) {
                        result = leg.rate.availableRate.Amount + this.getPackagesAmount(leg);
                    }                    
                } else {                    
                    if (leg.rate.rateGroupRate.Apply1stNightDepositRule) {
                        result = leg.rate.availableRate.Amount - leg.depositAmount + this.getPackagesAmount(leg);
                    }
                    else if (!leg.rate.availableRate.RequiresDeposit) {
                        result = leg.rate.availableRate.Amount + this.getPackagesAmount(leg);
                    }
                }
                return result;
            },
            getAddOnsTotal(leg) {
              
                let result = 0;

                if (leg.packages != undefined && leg.packages.length) {
                    for (let pi = 0; pi < leg.packages.length; pi++) {
                        let p = leg.packages[pi];
                        let amount = this.getPackagePrice(leg, p);
                        result += amount;
                    }
                }
                if (this.isTodayPayment) {
                    return result;
                } 
                return 0;

                //if (this.isTodayPayment) {
                //    if (leg.rate.availableRate.RequiresDeposit) {
                //        return result;
                //    }
                //    return 0;
                //} else {
                //    if (!leg.rate.availableRate.RequiresDeposit) {
                //        return result;
                //    }
                //    return 0;
                //}
            },
            getPackagePrice(leg, p) {
                if (p.item.availability.AmountOverride != undefined) {
                    return p.quantity * p.item.availability.AmountOverride;
                }

                let amount = p.item.availability.Amount;
                let postingMode = p.item.availability.PriceCalculationMode;
                let result = 0;

                switch (postingMode) {
                    case 0:
                        result = amount * p.quantity;
                        break;
                    case 1:

                        result = amount * leg.guestQuota.Adults;
                        break;
                    case 2:
                        result = amount * (leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 3:
                        result = amount * (leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants);
                        break;
                    case 4:
                        result = amount * p.quantity;
                        break;
                }
                return result;

            }
        }
    }
</script>

<style scoped>
    .total {
        font-size: 21px;
        display: inline-block;
    }

    .confirmation .to-pay{ max-width: 783px; padding-bottom: 40px!important; margin-bottom: 40px;}

    .total-price {
        display: inline-block;
        margin-left: 15px;
        font-weight: bold;
    }

    .bordered {
        border-left: solid 1px black;
    }

    .gift-voucher {
        color: #347f34;
    }
</style>